import { MSHttpEvent } from 'src/app/adapters/http/utils/http.utils';
import { TypeTransformerUseCase } from 'src/app/use-case/type-transformer/type-transformer.use-case';
import { BingMapsLocationData, BingMapsLocationHttpResponse } from '../../utils/bing-maps.utils';

const DISALLOWED_ENTITIES = ['Postcode1', 'RoadBlock'];

export namespace GeocodeEvent {
  export class Success {
    constructor(
      readonly hasValidAccuracy: boolean,
      readonly address: string,
      readonly latitude: number,
      readonly longitude: number
    ) {}
  }
  export class Error {}
  export class Loading {}

  export type Spec = Success | Error | Loading;
}

export function mapBingMapsLocationHttpResponseToGeocodeEvent(
  transformer: TypeTransformerUseCase,
  response: MSHttpEvent.Spec
): GeocodeEvent.Spec {
  if (response instanceof MSHttpEvent.Success) {
    const successEvent = mapLocationHttpErrorToGeocodeSuccessEvent(transformer, response);
    return successEvent;
  } else if (response instanceof MSHttpEvent.Error) {
    const errorEvent = mapLocationHttpErrorToGeocodeErrorEvent(response);
    return errorEvent;
  } else {
    const loadingEvent = new GeocodeEvent.Loading();
    return loadingEvent;
  }
}

function mapLocationHttpErrorToGeocodeSuccessEvent(transformer: TypeTransformerUseCase, response: MSHttpEvent.Success) {
  const data = transformer.transformToType(BingMapsLocationHttpResponse, response.data);
  const resources = getResourcesFromHttpResponse(data);
  const allowedResources = resources.filter((resource) => !DISALLOWED_ENTITIES.includes(resource.entityType));
  const hasValidAccuracy = allowedResources.length > 0;
  const validResource = hasValidAccuracy ? allowedResources[0] : resources[0];

  const successEvent = new GeocodeEvent.Success(
    hasValidAccuracy,
    validResource.address.formattedAddress,
    validResource.point.coordinates[0],
    validResource.point.coordinates[1]
  );
  return successEvent;
}

export function mapLocationHttpErrorToGeocodeErrorEvent(error: MSHttpEvent.Error): GeocodeEvent.Error {
  const errorEvent = new GeocodeEvent.Error();
  return errorEvent;
}

function getResourcesFromHttpResponse(data: BingMapsLocationHttpResponse): BingMapsLocationData[] {
  const resources: BingMapsLocationData[] = [];
  for (const resourceSet of data.resourceSets) {
    for (const resource of resourceSet.resources) {
      resources.push(resource);
    }
  }
  return resources;
}
